// extracted by mini-css-extract-plugin
module.exports = {"c7n-badge":"CountBadge_c7n-badge__2DK8g"};